const _compareToSort = (fa: any, fb: any) => {
  if (fa < fb) {
    return -1;
  }

  if (fa > fb) {
    return 1;
  }

  return 0;
};

export const sortStringArray = (a: string, b: string) => {
  const fa = a.toLowerCase();
  const fb = b.toLowerCase();

  return _compareToSort(fa, fb);
};

// TODO: consider the case of a[key] or b[key] are not string or number types
export const sortObjectsArrayByKey = (key: string) => (a: any, b: any) => {
  const aVal = a[key];
  const bVal = b[key];

  return bVal - aVal;
};
